export const page_url = 'https://silkroad.human.cmu.ac.th/admin/';
// export const page_url = 'http://localhost:3000/admin/';

export const api_url = 'https://silkroad.human.cmu.ac.th/api';
// export const api_url = `http://localhost/silkroad/api`;

export const img_url = api_url+'/images/';
